import iconAllow from 'assets/svgicon/allow.svg';

export default function Pagination(props) {
    const curPage = props.pagination.curPage;
    const perPage = props.pagination.perPage;
    const nextToken = props.pagination.nextToken;
    const startItem = (curPage - 1) * perPage + 1;
    const endItem = curPage * perPage > props.total ? props.total : curPage * perPage;
    const disabledNext = curPage * perPage >= props.total && !nextToken;
    const disabledPrev = curPage === 1;
    
  return (
    <div className="pagination_container">
      <div
        className="pagination-flex_row"
        style={{marginLeft: "0px", marginRight: "0px"}}
      >
        <label className="pagination-text">{`${startItem}-${endItem} 件`}</label>
        <button className="pagination-flex_row pagination_btn" disabled={disabledPrev} onClick={() => props.onChangePage(curPage - 1)}>
          <div className="pagination-flex_row pagination-flex_row">
            <img
              alt="allow"
              src={iconAllow}
              style={{transform: "rotate(180deg)"}}
            />
          </div>
          <label>{`前${perPage}件`}</label>
        </button>
        <button className="pagination-flex_row pagination_btn" disabled={disabledNext} onClick={() => props.onChangePage(curPage + 1)}>
          <label>{`次${perPage}件`}</label>
          <div className="pagination-flex_row">
            <img
              alt="allow"
              src={iconAllow}
            />
          </div>
        </button>
      </div>
    </div>
  );
}